import { gql } from '@apollo/client';

export const GET_SIMPLE_USER = gql`
  query getUser($id: ID!) {
    user(where: { id: $id }) {
      id
      firstName
      lastName
    }
  }
`;
